<template>
  <div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button color="info" outline @click.prevent="$router.push({ name: 'homework-create' })">{{ $t('add_new')
          }}</ts-button>
          <div class="d-flex">
            <ts-input v-model="search" :placeholder="$t('search')" style="width: 250px;" class="inline-block" />
            <ts-button outline class="ml-2" v-tooltip="$t('invoice.filter')" @click.prevent="visible = true">
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
        <!-- drawer -->
        <a-drawer :title="$t('filter')" placement="right" :closable="false" :visible="visible" @close="onCloseDrawer"
          :zIndex="1020" width="300px">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="ts-text-xs">{{ $t('homework.date') }}</label>
                <a-range-picker format="DD-MM-YYYY" :defaultValue="rangeDate" :defaultPickerValue="rangeDate"
                  @change="dateRangeChange">
                  <template slot="renderExtraFooter"></template>
                </a-range-picker>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="ts-text-xs">{{ $t('homework.status') }}</label>
                <a-select v-model="status" style="width:100%" @change="fetchData">
                  <a-select-option :value="1">{{
                    $t('eschool.progressing')
                  }}</a-select-option>
                  <a-select-option :value="2">{{
                    $t('eschool.closed')
                  }}</a-select-option>
                </a-select>
              </div>
            </div>
          </div>
        </a-drawer>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading" :rowGroup="{
          field: 'homework_date'
        }">
          <template v-slot="{ record }">
            <td>{{ record.teacher_name }}</td>
            <td>{{ record.class_name }}</td>
            <td>{{ record.subject_name }}</td>
            <td>{{ record.remarks }}</td>
            <td>
              <span class="label label-success" v-if="record.is_sent">Sent</span>
              <span class="label label-info" v-else>Pending</span>
            </td>
            <td>{{ record.sent_date }}</td>
            <td class="text-center">{{ record.student_homework_count }}</td>
            <td class="text-center">{{ record.input_score_count }}</td>
            <td class="text-left ts-whitespace-no-wrap">
              <a-switch size="small" :checked="record.status_open" @change="closeOpen(record)"
                :loading="homework_status_loading" />
              <a href="#" v-tooltip="$t('view')" class="ml-3 text-info" @click.prevent="showFormListView(record)"  v-if="record.homework_attachment.length > 0">
                <i class="fas fa-eye"></i>
              </a>
              <a href="#" class="text-primary ml-2" @click.prevent="edit(record)" v-if="!record.is_sent"
                v-tooltip="$t('edit')">
                <a-icon type="edit" />
              </a>
              <a href="#" class="ml-2 text-primary" v-tooltip="$t('homework.sendNotification')"
                v-if="!record.is_sent && record.approve_status == 2" @click="sendNotification(record)">
                <i class="far fa-paper-plane"></i>
              </a>
              <a href="#" class="ml-2 text-info" v-tooltip="$t('homework.comment')" v-if="record.is_sent"
                @click.prevent="onComment(record)">
                <a-icon type="message" />
              </a>
              <a href="#" class="text-primary" v-tooltip="$t('homework.correction')" v-if="record.is_sent"
                @click.prevent="
                  $router.push({
                    name: 'homework-correction',
                    params: { id: record.homework_id }
                  })
                  ">
                <a-icon type="carry-out" />
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
      <a-modal v-model="show_list_view" centered @ok="() => (show_list_view = false)" :zIndex="1020"
        :cancelText="$t('cancel')" :okText="$t('ok')" :footer="null" width="70%">
        <list-view ref="list_view" @fetchPhoto="getCurrentFile" @fetchNav="$emit('fetchNavi')" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import moment from 'moment'
import listView from './component/list-view.vue'

export default {
  name: 'homeworkStaff',
  components: {
    listView,
  },
  data() {
    return {
      homework_status_loading: false,
      loading: false,
      visible: false,
      show_list_view: false,
      view_record: null,
      rangeDate: [moment().add(-7, 'Day'), moment()]
    }
  },
  computed: {
    ...mapState('eschool/staffHomework', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.eschool.staffHomework.search
      },
      set(newValue) {
        this.$store.commit('eschool/staffHomework/SET_SEARCH', newValue)
        this.$store.commit('eschool/staffHomework/RESET_CURRENT_PAGE')
      }
    },
    status: {
      get() {
        return this.$store.state.eschool.staffHomework.status
      },
      set(newValue) {
        this.$store.commit('eschool/staffHomework/SET_STATUS_VALUE', newValue)
      }
    },
    columns() {
      return [
        { name: this.$t('homework.teacher') },
        { name: this.$t('homework.class') },
        { name: this.$t('homework.subject') },
        { name: this.$t('homework.remark') },
        { name: this.$t('homework.notification') },
        { name: this.$t('homework.sendDate') },
        {
          name: this.$t('homework.answer'),
          style: 'text-align:center; width:7%'
        },
        {
          name: this.$t('homework.getScore'),
          style: 'text-align:center; width:7%'
        },
        { name: this.$t('actions'), style: 'text-align:center; width:7%' }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    onCloseDrawer() {
      this.visible = false
    },
    fetchData(attributes = {}) {
      this.loading = true
      this.$store
        .dispatch('eschool/staffHomework/fetch')
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    edit(record) {
      this.$store.commit('eschool/staffHomework/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'homework-edit',
        params: { id: record.homework_id }
      })
    },
    dateRangeChange(dateRange) {
      this.$store.commit(
        'eschool/staffHomework/SET_DATE_FROM',
        dateRange[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'eschool/staffHomework/SET_DATE_TO',
        dateRange[1].format('DD-MM-YYYY')
      )
      this.fetchData()
    },
    closeOpen(record) {
      this.homework_status_loading = true
      this.$store
        .dispatch('eschool/staffHomework/changeStatus', {
          id: record.homework_id,
          data: {
            homework_status_id: record.homework_status_id
          }
        })
        .then(response => {
          record.status_open = record.status_open ? false : true
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.homework_status_loading = false
        })
    },
    onComment(record) {
      this.$router.push({
        name: 'homework-comment-public',
        params: { id: record.homework_id }
      })
    },
    sendNotification(record) {
      this.$confirm({
        title: this.$t('homework.confirmSend'),
        content:
          'All students and parents are going to see this homework and get notification',
        zIndex: 1020,
        okText: this.$t('yes'),
        cancelText: this.$t('no'),
        onOk: () => {
          return this.$store
            .dispatch(
              'eschool/staffHomework/sendNotification',
              record.homework_id
            )
            .then(response => {
              this.$toasted.success(response.message)
              this.fetchData()
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              this.errors = new Errors(error.errors)
              return Promise.reject(error)
            })
            .finally(() => {
              record._deleting = false
            })
        },
        onCancel() { },
        class: 'test'
      })
    },
    async showFormListView(items) {
      this.show_list_view = true
      this.view_record = items
      await this.getCurrentFile()

    },
    async getCurrentFile() {
      this.loadingPhoto = true
      this.homework_id = this.view_record.homework_id
      await this.$store
        .dispatch('eschool/staffHomework/getFile', this.homework_id)
        .then(() => (this.loadingPhoto = false))
        .finally(() => {
          this.loadingPhoto = false
        })
    },
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500)
  }
}
</script>
